// extracted by css-extract-rspack-plugin
export default {"elofleetList--padded":"elofleetList--padded-JQXO2h","elofleetListPadded":"elofleetList--padded-JQXO2h"};